module.exports = __webpack_public_path__ + "fonts/IQOS-Bold.524a442.ttf";